import React from "react";
import '../css/Home.css';

const Home = () => {
  return (
    <div className="home-overall">
      <h1>Welcome! You are celebrated</h1>
      <p>
        Mathematics is the science and study of quality, structure, space, and change.
        Mathematicians seek out patterns, formulate new conjectures, and establish truth by rigorous
        deduction from appropriately chosen axioms and definitions.
      </p>

      <p>
      Since the beginning of recorded history, mathematical discovery has been at the forefront of every civilized society, and math has been used by even the most primitive and earliest cultures. The need for math arose because of the increasingly complex demands from societies around the world, which required more advanced mathematical solutions.
      </p>
    </div>
  );
};

export default Home;
